import {Component} from '@angular/core';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.css'],
    standalone: false
})
export class TopBarComponent {
  public countryShort: string = "nl";

  /**
   * Handles navigation by opening the given URL in a new tab/window.
   * @param {string} url - The URL to navigate to.
   * @return {void}
   */
  navigationHandler(url: string): void {
    window.open(url, "_blank");
  }
}
